<div>
  <div class="add-commission">
    <div class="header">
      @if (mode === 'edit') {
        <h2 class="title">Edit Commission for {{ commissionState.name }}</h2>
      }
      @if (mode === 'add') {
        <h2 class="title">Add Commission for {{ commissionState.name }}</h2>
      }
    </div>

    <ng-container>
      <div class="modal-body">
        <form [formGroup]="commissionForm" class="clrsgn-form">
          <div class="disclaimer">*Required Information</div>
          <div class="row">
            <div class="col-12 label">
              Location
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <mat-form-field appearance="fill" class="clrsgn-form-field">
                <mat-label for="county" class="clrsgn-label">County</mat-label>
                <mat-select formControlName="county" id="county">
                  @for (county of countyDropDownList; track county) {
                    <mat-option
                      [value]="county.countyFIPSCode">
                      {{ county.countyName }}
                    </mat-option>
                  }
                </mat-select>
                <app-form-error [group]="commissionForm" [controlName]="'county'"></app-form-error>
              </mat-form-field>
            </div>
          </div>
          @if (countySelected) {
            <div class="row">
              <div class="col-12 label">
                Details
              </div>
            </div>
          } @else {
            <ng-template [ngTemplateOutlet]="noCommissionLocation"></ng-template>
          }
          @if (countySelected) {
            <div class="row">
              <div class="col-6">
                <mat-form-field appearance="fill" class="clrsgn-form-field">
                  <mat-label for="commissionName" class="clrsgn-label">Name on Commission</mat-label>
                  <input matInput
                    type="text"
                    formControlName="commissionName"
                    id="commissionName" />
                    <app-form-error [group]="commissionForm" [controlName]="'commissionName'"></app-form-error>
                  </mat-form-field>
                </div>
                @if ((selectedRule | async)?.isCommissionNumberRequired) {
                  <div class="col-6">
                    <mat-form-field appearance="fill" class="clrsgn-form-field">
                      <mat-label for="commissionNumber" class="clrsgn-label">Commission #<span class="required-indicator">*</span></mat-label>
                      <input matInput
                        type="text"
                        formControlName="commissionNumber"
                        id="commissionNumber" />
                        <app-form-error [group]="commissionForm" [controlName]="'commissionNumber'"></app-form-error>
                      </mat-form-field>
                    </div>
                  }
                  <div class="col-6">
                    <mat-form-field appearance="fill" class="clrsgn-form-field">
                      <mat-label for="commissionExpiration" class="clrsgn-label">
                        Expiration Date
                      </mat-label>
                      <input matInput
                        [matDatepicker]="scheduledDatepicker"
                        [min]="minDate"
                        formControlName="commissionExpiration"
                        id="commissionExpiration"
                        [formGroup]="commissionForm" />
                        <mat-datepicker-toggle matSuffix [for]="scheduledDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #scheduledDatepicker></mat-datepicker>
                        <app-form-error [group]="commissionForm"
                        [controlName]="'commissionExpiration'"></app-form-error>
                      </mat-form-field>
                    </div>
                  </div>
                  @if (!((selectedRule | async)?.isAutoGeneratedStampAllowed)) {
                    <div class="row">
                      <div class="col-6">
                        <div class="form-group">
                          <label>Stamp:</label>
                          <app-file-upload id="stampFileUpload" formControlName="stamp" (change)="onFileSelected($event, 'stamp')"></app-file-upload>
                          <app-form-error [group]="commissionForm"
                            [controlName]="'stamp'"
                          [customErrorMessage]="'Please select a .PNG file'"></app-form-error>
                        </div>
                      </div>
                    </div>
                  }
                  @if (!stampHasErrors && (hasStamp || (stampUploaded | async))) {
                    <div class="row">
                      @if (primaryStamp || selectedStampBase64) {
                        <div class="col-6">
                          <ng-container>
                            @if (primaryStamp) {
                              <label>Stamp Preview:</label>
                              } <br />
                              @if (primaryStamp?.base64String) {
                                <div>
                                  <img [src]="getSanitizedImage(primaryStamp?.base64String)" class="stamp-image" alt="" />
                                </div>
                              }
                              @if (selectedStampBase64 && !primaryStamp.base64String) {
                                <div>
                                  <img [src]="getSanitizedImage(selectedStampBase64)" class="stamp-image" alt="" />
                                </div>
                              }
                            </ng-container>
                          </div>
                        }
                        @if (ronStamp) {
                          <div class="col-6">
                            <ng-container>
                              @if (ronStamp) {
                                <label>RON Stamp Preview:</label>
                                } <br />
                                @if (ronStamp?.base64String) {
                                  <div>
                                    <img [src]="getSanitizedImage(ronStamp?.base64String)" class="stamp-image" alt="" />
                                  </div>
                                }
                              </ng-container>
                            </div>
                          }
                          @if (ipenStamp) {
                            <div class="col-6">
                              <ng-container>
                                @if (ipenStamp?.base64String) {
                                  <label>IPEN Stamp Preview:</label>
                                  } <br />
                                  @if (ipenStamp?.base64String) {
                                    <div>
                                      <img [src]="getSanitizedImage(ipenStamp?.base64String)" class="stamp-image" alt="" />
                                    </div>
                                  }
                                </ng-container>
                              </div>
                            }
                          </div>
                        }
                      } @else {
                        <ng-template [ngTemplateOutlet]="noCommissionLocation"></ng-template>
                      }
                    </form>
                  </div>
                  <div class="footer">
                    <button type="button" class="btn-secondary me-3" (click)="close()">Cancel</button>
                    <button type="button" class="btn-primary" (click)="saveCommission()">Save</button>
                  </div>
                </ng-container>
              </div>
            </div>
